import { CompanyProtocolApplications } from '../modules/protocols/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { ProtocolApplicationsView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyProtocolApplicationsScreen({
  view,
  onView,
}: {
  view: ProtocolApplicationsView;
  onView: ViewSetter<ProtocolApplicationsView>;
}) {
  const { can, timeZone, company } = useCompanyScope();
  const units = company.businessUnits ?? [];
  const consolidated = units.length > 1 && (company.activeBusinessUnitId ?? null) === null;
  return (
    <GatedCompanyScreen allowed={can('protocols.applications.read')}>
      <CompanyProtocolApplications
        capabilities={{ canManage: !consolidated && can('protocols.applications.manage') }}
        consolidated={consolidated}
        timeZone={timeZone}
        view={view}
        onView={onView}
      />
    </GatedCompanyScreen>
  );
}
